export default __webpack_public_path__ + "static/media/Samy-Felice.3a0eec7d.jpg";